import { useLang } from '@common/hooks/use-lang';
import LogoDe from '@assets/emi-logo-de.svg?react';
import LogoFr from '@assets/emi-logo-fr.svg?react';
import LogoIt from '@assets/emi-logo-it.svg?react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import React, { FC, HTMLProps, useMemo } from 'react';
import classes from './brand-logo.module.scss';

export type BrandLogoProps = Omit<HTMLProps<HTMLDivElement>, 'size'> & {
  src?: string;
  alt?: string;

  /**
   * Override default sizing. Used within the nav bar
   */
  size?: 'small';
};

export const BrandLogo: FC<BrandLogoProps> = ({ src, alt, size, ...props }) => {
  const { t } = useTranslation();
  const language = useLang('de');

  const content = useMemo(() => {
    if (src) {
      return <img className={classes.image} src={src} alt={alt || t<string>('common.brand-logo')} />;
    }

    switch (language) {
      case 'fr':
        return <LogoFr className={classes.logo} />;
      case 'it':
        return <LogoIt className={classes.logo} />;
      default:
        return <LogoDe className={classes.logo} />;
    }
  }, [src, alt, language]);

  return (
    <div
      {...props}
      className={clsx(classes.root, props.className, {
        [classes.small]: size === 'small',
      })}
    >
      {content}
    </div>
  );
};
